import { useTheme } from '../../../hooks/useTheme';
import StaggerReveal from '../../../components/feature/StaggerReveal';
import { dentalBenefits } from '../../../mocks/dental';

const ACCENTS = ['#06b6d4', '#14b8a6', '#00cfff', '#2dd4bf', '#0ea5e9', '#5eead4', '#22d3ee', '#0d9488'];

export default function DentalValue() {
  const { theme } = useTheme();
  const isLight = theme === 'light';
  const accentText = isLight ? '#0f766e' : '#14b8a6';

  const ink = isLight ? '#0a1628' : '#ffffff';
  const sub = isLight ? 'rgba(10,22,40,0.72)' : 'rgba(255,255,255,0.55)';
  const border = isLight ? 'rgba(10,22,40,0.09)' : 'rgba(255,255,255,0.07)';

  return (
    <section
      id="valor-odontologia"
      className="py-14 md:py-20 px-4 sm:px-6 scroll-mt-24"
      style={{
        background: isLight
          ? 'linear-gradient(180deg, #ffffff 0%, #f6fafd 100%)'
          : 'linear-gradient(180deg, #071b2e 0%, #04101f 100%)',
        borderTop: `1px solid ${border}`,
      }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span
            className="inline-block text-xs md:text-sm font-semibold tracking-widest uppercase font-body mb-2.5"
            style={{ color: isLight ? '#0e7490' : '#22d3ee' }}
          >
            Plataforma integral
          </span>
          <h2
            className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold mb-3"
            style={{ color: ink }}
          >
            Mucho más que una{' '}
            <span style={{ color: accentText }}>agenda odontológica</span>
          </h2>
          <p className="font-body text-sm md:text-base max-w-2xl mx-auto" style={{ color: sub }}>
            Consultorios, clínicas, centros odontológicos y redes con varias sucursales operan lo
            clínico, lo administrativo y lo financiero desde el mismo lugar.
          </p>
        </div>

        <StaggerReveal
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 items-stretch"
          staggerDelay={60}
        >
          {dentalBenefits.map((benefit, i) => {
            const accent = ACCENTS[i % ACCENTS.length];
            return (
              <article
                key={benefit.title}
                className="h-full rounded-2xl border p-5 flex flex-col"
                style={{
                  borderColor: border,
                  background: isLight ? '#ffffff' : 'rgba(7,27,46,0.75)',
                  boxShadow: isLight ? '0 2px 12px rgba(10,22,40,0.05)' : 'none',
                }}
              >
                <div
                  className="w-11 h-11 flex items-center justify-center rounded-xl mb-3.5 flex-shrink-0"
                  style={{ backgroundColor: accent + '1a', color: accent }}
                >
                  <i className={`${benefit.icon} text-xl`} aria-hidden="true" />
                </div>
                <h3
                  className="font-heading text-sm md:text-base font-bold mb-2 leading-snug"
                  style={{ color: ink }}
                >
                  {benefit.title}
                </h3>
                <p className="font-body text-xs md:text-[13px] leading-relaxed" style={{ color: sub }}>
                  {benefit.desc}
                </p>
              </article>
            );
          })}
        </StaggerReveal>
      </div>
    </section>
  );
}
